import { Component } from "@angular/core";
import { UntilDestroy } from "@ngneat/until-destroy";

@UntilDestroy({checkProperties: true})
@Component({
  selector: 'app-layout-admin',
  templateUrl: 'layout-admin.component.html',
  styleUrls: ['layout-admin.component.scss']
})
export class LayoutAdminComponent {

  constructor() {
  }

}
